<template>
  <v-main>
    <!-- / Mini Variant Sidebar -->
    <v-container fluid>
      <br />
      <v-row justify="start">
        <v-col md="8">
          <backbutton v-if="roleName != 'Supplier'"></backbutton>
          <h1
            class="dj-page-title dj-page-title--inline"
            v-text="
              ` ${capitalize($route.query.type)} Modules for ${capitalize(
                project.type
              )} : ${project.name}`
            "
          ></h1>
          <!-- <v-col sm="4" v-if="form.type == 'PROJECT'"> -->

          <v-tooltip right v-if="project.type == 'TEMPLATE'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="show_supplier_list = true"
                icon
                ><v-icon>mdi-email</v-icon></v-btn
              >
            </template>
            <span>Send Template</span>
          </v-tooltip>
        </v-col>
        <v-col sm="2" v-if="project.type == 'QUOTATION'">
          <input type="file" id="doc" name="doc" ref="doc" multiple />
        </v-col>
        <v-col sm="2" v-if="project.type == 'QUOTATION'">
          <v-btn
            dark
            color="indigo"
            @click="handleFileQuotationDocumentUpload()"
            >Save
          </v-btn>
        </v-col>
        <v-col md="3" v-if="project.type == 'PROJECT'">
          <v-autocomplete
            v-if="project.created_by_id == user.id || roleName != 'Handler'"
            ref="category"
            dense
            v-model="form.quotation_id"
            :items="quotationItems"
            label="Select Quotation"
            messages="Kindly Select any quotation to Copy"
            prepend-inner-icon="mdi-content-paste"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col
          md="1"
          v-if="project.type == 'PROJECT' && form.quotation_id != 0"
        >
          <v-btn
            :disabled="!form.quotation_id"
            dark
            color="indigo"
            @click="openCopyQuotation"
            >Check
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="4">
          <v-card elevation="6" height="583">
            <!-- style="overflow-y: auto; overflow-x: auto" -->
            <v-container>
              <v-row>
                <div
                  id="buttons"
                  v-if="
                    roleName == 'Main Admin' ||
                    (project.created_by_id == user.id && roleName == 'Handler')
                  "
                >
                  <v-col>
                    <v-btn
                      color="orange"
                      small
                      class="mx-2"
                      dark
                      @click="createNewModule()"
                    >
                      New Category
                    </v-btn>
                    <v-btn
                      color="cyan"
                      small
                      class="mx-2"
                      dark
                      v-if="
                        (selectedNode.node_type == 'module' ||
                          (selectedNode.node_type == 'module_job' &&
                            selectedNode.category != 'SPARES')) &&
                        selectedNode.id &&
                        selectedNode.category?.name != 'SPARES'
                      "
                      @click="addJob(selectedNode)"
                    >
                      Add Jobs
                    </v-btn>
                    <v-btn
                      color="green"
                      small
                      class="mx-2"
                      dark
                      v-if="selectedNode.category?.name == 'SPARES'"
                      @click="addJob(selectedNode)"
                    >
                      Add Spares
                    </v-btn>
                  </v-col>
                </div>
              </v-row>
              <br />
              <v-treeview
                :items="treeData"
                shaped
                activatable
                @update:active="getActiveValue"
                ><template v-slot:label="{ item }">
                  <span
                    :class="{
                      bold: !!(item.title == 'SPARES'),
                    }"
                  >
                    {{ item.name }}
                  </span>
                </template></v-treeview
              >
            </v-container>
          </v-card>
        </v-col>
        <v-col md="8">
          <v-card elevation="6" v-if="selectedNode.node_type">
            <v-container>
              <!-- Module Section -->
              <div v-if="selectedNode.node_type == 'module'">
                <v-row>
                  <v-col>
                    <h3>{{ selectedNode.id ? "Update" : "Create" }} Module</h3>
                  </v-col>
                  <v-col>
                    <v-tooltip
                      left
                      v-if="
                        (module.module_jobs.length &&
                          project.created_by_id == user.id) ||
                        roleName != 'Handler'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="primary"
                          icon
                          @click="showModuleTimeline(module)"
                        >
                          <v-icon>mdi-chart-timeline</v-icon>
                        </v-btn>
                      </template>
                      <span>Module Timeline</span>
                    </v-tooltip>
                    <v-tooltip right v-if="module.id">
                      <template
                        v-slot:activator="{ on, attrs }"
                        v-if="
                          project.created_by_id == user.id ||
                          roleName != 'Handler'
                        "
                      >
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="primary"
                          icon
                          @click="delete_data(module.id, 'modules')"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete Module</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="4">
                    <v-autocomplete
                      ref="category"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                      v-model="module.category_id"
                      :items="categoryItems"
                      @change="getSubCategory"
                      label="Select Category"
                      prepend-inner-icon="mdi-ferry"
                      outlined
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col sm="4" v-if="sub_categoryItems.length > 1">
                    <v-autocomplete
                      ref="sub_category"
                      :readonly="
                        (project.created_by_id != user.id &&
                          roleName == 'Handler') ||
                        roleName != 'Handler'
                      "
                      v-model="module.sub_category_id"
                      :items="sub_categoryItems"
                      label="Select Sub Category"
                      prepend-inner-icon="mdi-ferry"
                      outlined
                    ></v-autocomplete>
                  </v-col>
                  <v-col sm="4" v-if="project.type == 'PROJECT'">
                    <v-text-field
                      v-model="module.allocated_budget"
                      outlined
                      label="Allocated budget *"
                      prepend-inner-icon="mdi-cash-100"
                      :error-messages="errors.allocated_budget"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      v-if="
                        project.created_by_id == user.id ||
                        roleName != 'Handler'
                      "
                      :loading="isSaving"
                      :disabled="isSaving"
                      color="primary"
                      @click="saveModule"
                    >
                      Save Module
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
              <!-- End Of Module Section -->
              <!-- Module Job Section -->
              <div v-else>
                <v-row>
                  <v-col>
                    <h3>
                      CATEGORY : {{ module.category.name }}
                      {{
                        selectedNode.node_type == "sub_module_job"
                          ? "Of " + moduleJob.name
                          : ""
                      }}
                    </h3>
                    {{ selectedNode.category?.name }}
                  </v-col>
                  <v-col v-if="selectedNode.id">
                    <v-tooltip
                      left
                      v-if="
                        (project.type == 'PROJECT' &&
                          project.created_by_id == user.id) ||
                        roleName != 'Handler'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                          color="primary"
                          icon
                          @click="showFeedback(selectedNode)"
                        >
                          <v-icon>mdi-comment-quote</v-icon>
                        </v-btn>
                      </template>
                      <span>Feedback</span>
                    </v-tooltip>
                    <v-tooltip top v-if="project.type == 'QUOTATION'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                          color="primary"
                          icon
                          @click="showModuleJobTimeline(selectedNode)"
                        >
                          <v-icon>mdi-chart-timeline</v-icon>
                        </v-btn>
                      </template>
                      <span>Job Timeline</span>
                    </v-tooltip>
                    <v-tooltip
                      right
                      v-if="
                        project.created_by_id == user.id ||
                        roleName != 'Handler'
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          class="mx-2"
                          color="primary"
                          icon
                          @click="delete_data(selectedNode.id, 'module_jobs')"
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete Job</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    v-if="
                      project.created_by_id == user.id || roleName != 'Handler'
                    "
                  >
                    <v-btn
                      :loading="isSaving"
                      small
                      :disabled="isSaving"
                      color="primary"
                      @click="saveModuleJob"
                    >
                      Save
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col>
                    <v-text-field
                      v-model="selectedNode.name"
                      outlined
                      dense
                      label="Name"
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                      :error-messages="errors.name"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-select
                      v-if="project.type != 'TEMPLATE'"
                      v-model="selectedNode.supplier_id"
                      :items="supplierItems"
                      outlined
                      label="Vendor Name"
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    >
                    </v-select>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col>
                    <v-textarea
                      v-model="selectedNode.description"
                      outlined
                      hide-details="auto"
                      class="mb-0"
                      rows="2"
                      label="Job Description"
                      clearable
                      clear-icon="mdi-close-circle"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row
                  v-if="
                    project.type != 'TEMPLATE' &&
                    module.category.name != 'SPARES'
                  "
                >
                  <v-col>
                    <v-menu
                      v-model="selectedNode.estimate_start_date_menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Select Estimate Start Date"
                          v-model="selectedNode.estimate_start_date"
                          :id="`estimate_start_date`"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details="auto"
                          :error-messages="errors.estimate_start_date"
                        ></v-text-field>
                      </template>

                      <v-date-picker
                        :id="`estimate_start_date`"
                        v-model="selectedNode.estimate_start_date"
                        :readonly="
                          project.created_by_id != user.id &&
                          roleName == 'Handler'
                        "
                        @change="selectedNode.estimate_start_date_menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="selectedNode.estimate_end_date_menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Select Estimate End Date"
                          v-model="selectedNode.estimate_end_date"
                          :id="`estimate_end_date`"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details="auto"
                          :error-messages="errors.estimate_end_date"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :id="`estimate_end_date`"
                        v-model="selectedNode.estimate_end_date"
                        @change="selectedNode.estimate_end_date_menu = false"
                        :readonly="
                          project.created_by_id != user.id &&
                          roleName == 'Handler'
                        "
                      ></v-date-picker>
                      <!-- :min="selectedNode.estimate_start_date" -->
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="selectedNode.actual_start_date_menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Select Actual Start Date"
                          v-model="selectedNode.actual_start_date"
                          :id="`actual_start_date`"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :id="`actual_start_date`"
                        v-model="selectedNode.actual_start_date"
                        @change="selectedNode.actual_start_date_menu = false"
                        :readonly="
                          project.created_by_id != user.id &&
                          roleName == 'Handler'
                        "
                      ></v-date-picker>
                      <!-- :min="nowDate" -->
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="selectedNode.actual_end_date_menu"
                      :close-on-content-click="false"
                      :nudge-left="0"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          label="Select Actual End Date"
                          v-model="selectedNode.actual_end_date"
                          :id="`actual_end_date`"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :id="`actual_end_date`"
                        v-model="selectedNode.actual_end_date"
                        @change="
                          (selectedNode.actual_end_date_menu = false),
                            (selectedNode.status = 2)
                        "
                        :readonly="
                          project.created_by_id != user.id &&
                          roleName == 'Handler'
                        "
                      >
                      </v-date-picker>
                      <!-- :min="selectedNode.actual_start_date" -->
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col>
                    <v-text-field
                      :label="`Expected Cost ${
                        project.type == 'TEMPLATE' ? '/ Hrs' : ''
                      }`"
                      type="number"
                      v-model="selectedNode.expected_cost"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :label="`Expected Qty ${
                        project.type == 'TEMPLATE' ? '/ Hrs' : ''
                      }`"
                      type="number"
                      v-model="selectedNode.expected_qty"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      :label="`Qty ${
                        project.type == 'TEMPLATE' ? '/ Hrs' : ''
                      }`"
                      type="number"
                      v-model="selectedNode.qty"
                      @change="calculated(selectedNode)"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Cost"
                      type="number"
                      v-model="selectedNode.cost"
                      @change="calculated(selectedNode)"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Discount in %"
                      type="number"
                      v-model="selectedNode.discount_percentage"
                      @change="calculated(selectedNode)"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col>
                    <v-text-field
                      label="Discount amount"
                      type="number"
                      v-model="selectedNode.discount_amount"
                      @change="calculated(selectedNode)"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Additional in %"
                      type="number"
                      v-model="selectedNode.additional_percentage"
                      @change="calculated(selectedNode)"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Additional Amount"
                      type="number"
                      v-model="selectedNode.additional_amount"
                      @change="calculated(selectedNode)"
                      outlined
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="selectedNode.currency_id"
                      :items="currencyItems"
                      outlined
                      label="Currency"
                      dense
                      hide-details="auto"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    >
                    </v-select>
                  </v-col>

                  <v-col>
                    <v-text-field
                      v-model="selectedNode.total_cost"
                      outlined
                      readonly
                      dense
                      label="Total Cost"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col>
                    <v-text-field
                      v-model="selectedNode.total_handling_charge"
                      outlined
                      :readonly="
                        project.type != 'TEMPLATE'
                          ? true
                          : false ||
                            (project.created_by_id != user.id &&
                              roleName == 'Handler')
                      "
                      dense
                      label="Total handling Cost"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col>
                    <v-textarea
                      v-model="selectedNode.remark"
                      outlined
                      counter
                      rows="2"
                      label="Remarks"
                      clearable
                      clear-icon="mdi-close-circle"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-textarea>
                  </v-col>
                  <v-col v-if="project.type != 'TEMPLATE'">
                    <v-textarea
                      v-model="selectedNode.delayed_reason"
                      outlined
                      counter
                      rows="2"
                      label="Delayed Reason"
                      clearable
                      clear-icon="mdi-close-circle"
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row v-if="module.category.name != 'SPARES'">
                  <v-col v-if="project.type != 'TEMPLATE'">
                    <v-select
                      v-model="selectedNode.status"
                      :items="statusItems"
                      chips
                      item-color="red"
                      label="Status"
                      class="mt-2"
                      dense
                      :readonly="
                        project.created_by_id != user.id &&
                        roleName == 'Handler'
                      "
                    >
                    </v-select>
                  </v-col>
                  <v-col v-if="project.type == 'PROJECT'">
                    <input
                      type="file"
                      id="file"
                      name="file"
                      ref="file"
                      multiple
                    />
                    <v-tooltip
                      bottom
                      v-if="selectedNode.module_job_documents?.length"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          icon
                          @click="show_module_job_document = true"
                          ><v-icon>mdi-paperclip</v-icon></v-btn
                        >
                      </template>
                      <span>View Documents</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <!-- Module Job Spares Section -->
                <v-row v-if="project.type != 'TEMPLATE'">
                  <v-col md="12">
                    <h3>List of Spares</h3>
                  </v-col>
                  <v-col>
                    <v-simple-table
                      fixed-header
                      :height="`${
                        selectedNode.module_job_spares.length ? '300px' : ''
                      }`"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th style="min-width: 70px" class="text-left">
                              Sr No
                            </th>
                            <th style="min-width: 300px" class="text-left">
                              Description
                            </th>
                            <th style="min-width: 300px" class="text-left">
                              Vendor Name
                            </th>
                            <th style="min-width: 140px" class="text-left">
                              Order Date
                            </th>
                            <th style="min-width: 155px" class="text-left">
                              Expected delivery Date
                            </th>
                            <th style="min-width: 155px" class="text-left">
                              Actual delivery Date
                            </th>
                            <th style="min-width: 130px" class="text-left">
                              Cost
                            </th>
                            <th style="min-width: 155px" class="text-left">
                              Transportation cost
                            </th>
                            <th style="min-width: 150px" class="text-left">
                              Total cost
                            </th>
                            <th style="min-width: 130px" class="text-left">
                              Status
                            </th>
                            <th style="min-width: 280px" class="text-left">
                              Remarks
                            </th>
                            <th style="min-width: 280px" class="text-left">
                              Delayed Reason
                            </th>
                            <th style="min-width: 100px" class="text-right">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(mjs, i) in selectedNode.module_job_spares"
                            :key="`mjs${i}`"
                          >
                            <td>{{ i + 1 }}</td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjs.description"
                                  outlined
                                  dense
                                  label="Description"
                                  hide-details="auto"
                                  :error-messages="
                                    mjs.description == ''
                                      ? 'this description field is required'
                                      : ''
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-select
                                  v-model="mjs.supplier_id"
                                  :items="supplierItems"
                                  outlined
                                  label="Vendor Name"
                                  dense
                                  hide-details="auto"
                                  :error-messages="
                                    mjs.id == ''
                                      ? 'this vendor name field is required'
                                      : ''
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                >
                                </v-select>
                                <!-- <v-text-field
                                  v-model="mjs.supplier_name"
                                  outlined
                                  dense
                                  label="Supplier Name"
                                  hide-details="auto"
                                  :error-messages="
                                    mjs.supplier_name == ''
                                      ? 'this supplier name field is required'
                                      : ''
                                  "
                                ></v-text-field> -->
                              </v-col>
                            </td>
                            <td>
                              <v-menu
                                v-model="mjs.order_date_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    label="Select Order Date"
                                    v-model="mjs.order_date"
                                    :id="`order_date${i}`"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    :error-messages="
                                      mjs.order_date == ''
                                        ? 'this order date field is required'
                                        : ''
                                    "
                                    class="mt-6"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </template>

                                <v-date-picker
                                  :id="`order_date${i}`"
                                  v-model="mjs.order_date"
                                  @change="mjs.order_date_menu = false"
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-date-picker>
                              </v-menu>
                            </td>
                            <td>
                              <v-menu
                                v-model="mjs.expected_delivery_date_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    label="Select Estimate End Date"
                                    v-model="mjs.expected_delivery_date"
                                    :id="`expected_delivery_date${i}`"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mt-6"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </template>

                                <v-date-picker
                                  :id="`expected_delivery_date${i}`"
                                  v-model="mjs.expected_delivery_date"
                                  @change="
                                    mjs.expected_delivery_date_menu = false
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-date-picker>
                              </v-menu>
                            </td>
                            <td>
                              <v-menu
                                v-model="mjs.actual_delivery_date_menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    label="Select Actual Delivery Date"
                                    v-model="mjs.actual_delivery_date"
                                    :id="`actual_delivery_date${i}`"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mt-6"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </template>

                                <v-date-picker
                                  :id="`actual_delivery_date${i}`"
                                  v-model="mjs.actual_delivery_date"
                                  @change="
                                    mjs.actual_delivery_date_menu = false
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-date-picker>
                              </v-menu>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjs.cost"
                                  outlined
                                  dense
                                  label="Cost"
                                  @change="calculated_total(mjs)"
                                  hide-details="auto"
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjs.transportation_cost"
                                  outlined
                                  @change="calculated_total(mjs)"
                                  dense
                                  label="Transportation Cost"
                                  hide-details="auto"
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjs.total_cost"
                                  outlined
                                  readonly
                                  dense
                                  label="Total Cost"
                                  hide-details="auto"
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-select
                                  v-model="mjs.status"
                                  :items="SparestatusItems"
                                  chips
                                  item-color="red"
                                  label="Status"
                                  class="mt-6"
                                  outlined
                                  dense
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                >
                                </v-select>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-textarea
                                  label="Remarks"
                                  v-model="mjs.remark"
                                  rows="2"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  outlined
                                  dense
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-textarea>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-textarea
                                  label="Delayed reason"
                                  v-model="mjs.delayed_reason"
                                  rows="2"
                                  clearable
                                  clear-icon="mdi-close-circle"
                                  outlined
                                  dense
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-textarea>
                              </v-col>
                            </td>
                            <td class="text-right">
                              <div class="text-center">
                                <v-tooltip
                                  bottom
                                  v-if="
                                    !mjs.id ||
                                    project.created_by_id == user.id ||
                                    roleName != 'Handler'
                                  "
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      color="primary"
                                      icon
                                      @click="deleteModuleJobSpare(mjs)"
                                    >
                                      <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Delete</span>
                                </v-tooltip>
                                <v-tooltip bottom v-else>
                                  <template
                                    v-slot:activator="{ on, attrs }"
                                    v-if="
                                      project.created_by_id == user.id &&
                                      roleName == 'Handler'
                                    "
                                  >
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      color="primary"
                                      icon
                                      @click="
                                        delete_data(mjs.id, 'module_job_spares')
                                      "
                                    >
                                      <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Delete Spare</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                          <tr
                            v-if="
                              project.created_by_id == user.id ||
                              roleName != 'Handler'
                            "
                          >
                            <td colspan="16">
                              <v-btn
                                outlined
                                block
                                color="primary"
                                @click="addEmptyModuleJobSpare()"
                              >
                                Add Spare
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <!-- End of Module Job Spares Section -->
                <!-- Module Job Quantities Section -->
                <v-row
                  v-if="
                    module.category.name != 'SPARES' &&
                    project.type == 'QUOTATION'
                  "
                >
                  <v-col md="12">
                    <h3>List of Quantities</h3>
                  </v-col>
                  <v-col>
                    <v-simple-table
                      fixed-header
                      :height="`${
                        selectedNode.module_job_quantities?.length
                          ? '300px'
                          : ''
                      }`"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th style="min-width: 70px" class="text-left">
                              Sr No
                            </th>
                            <th
                              style="min-width: 300px"
                              class="text-left"
                              v-if="logged_in_as == 'ADMIN'"
                            >
                              Supplier Name
                            </th>
                            <th style="min-width: 155px" class="text-left">
                              Meassure
                            </th>
                            <th style="min-width: 300px" class="text-left">
                              Qty
                            </th>
                            <th style="min-width: 140px" class="text-left">
                              Unit Cost
                            </th>
                            <th style="min-width: 150px" class="text-left">
                              Total cost
                            </th>
                            <th style="min-width: 130px" class="text-left">
                              Type
                            </th>
                            <th style="min-width: 100px" class="text-right">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(
                              mjq, i
                            ) in selectedNode.module_job_quantities"
                            :key="`mjq${i}`"
                          >
                            <td>{{ i + 1 }}</td>
                            <td v-if="logged_in_as == 'ADMIN'">
                              <v-col class="px-0">
                                <v-select
                                  v-model="mjq.supplier_id"
                                  :items="supplierItems"
                                  outlined
                                  label="Supplier Name"
                                  dense
                                  hide-details="auto"
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                >
                                </v-select>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjq.measure"
                                  outlined
                                  dense
                                  label="Meassure"
                                  hide-details="auto"
                                  :error-messages="
                                    mjq.measure == ''
                                      ? 'this meassure field is required'
                                      : ''
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjq.qty"
                                  outlined
                                  dense
                                  label="Quantity"
                                  @keyup="calculate_mjq(mjq)"
                                  hide-details="auto"
                                  :error-messages="
                                    mjq.qty == ''
                                      ? 'this qty field is required'
                                      : ''
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjq.unit_cost"
                                  outlined
                                  dense
                                  @keyup="calculate_mjq(mjq)"
                                  label="Per Unit Cost"
                                  hide-details="auto"
                                  :error-messages="
                                    mjq.unit_cost == ''
                                      ? 'this unit cost field is required'
                                      : ''
                                  "
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-text-field
                                  v-model="mjq.total_cost"
                                  outlined
                                  readonly
                                  dense
                                  label="Total Cost"
                                  hide-details="auto"
                                ></v-text-field>
                              </v-col>
                            </td>
                            <td>
                              <v-col class="px-0">
                                <v-select
                                  v-model="mjq.type"
                                  :items="QuantityTypeItems"
                                  chips
                                  item-color="red"
                                  label="Status"
                                  class="mt-6"
                                  outlined
                                  dense
                                  :readonly="
                                    project.created_by_id != user.id &&
                                    roleName == 'Handler'
                                  "
                                >
                                </v-select>
                              </v-col>
                            </td>
                            <td class="text-right">
                              <div class="text-center">
                                <v-tooltip
                                  bottom
                                  v-if="
                                    !mjq.id || project.created_by_id == user.id
                                  "
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      color="primary"
                                      icon
                                      @click="deleteModuleJobQuantity(mjq)"
                                    >
                                      <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Delete</span>
                                </v-tooltip>
                                <v-tooltip bottom v-else>
                                  <template
                                    v-slot:activator="{ on, attrs }"
                                    v-if="project.created_by_id == user.id"
                                  >
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      small
                                      color="primary"
                                      icon
                                      @click="
                                        delete_data(
                                          mjq.id,
                                          'module_job_quantities'
                                        )
                                      "
                                    >
                                      <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Delete Quantity</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                          <tr
                            v-if="
                              project.created_by_id == user.id ||
                              roleName != 'Handler'
                            "
                          >
                            <td colspan="16">
                              <v-btn
                                outlined
                                block
                                color="primary"
                                @click="addEmptyModuleJobQuantity()"
                              >
                                Add Quantities
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <!-- End of Module Job Spares Section -->
              </div>
              <!-- End Of Module Job Section -->
            </v-container>
            <!--/ Edit Existing Module -->
          </v-card>
        </v-col>
      </v-row>
      <!-- Module Timeline Pop UP  -->
      <v-dialog v-model="show_module_details" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>Module Timeline</h2>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_module_details = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-row>
              <v-simple-table fixed-header height="250px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th style="min-width: 120px">Name</th>
                      <th style="min-width: 120px">Workshop Name</th>
                      <th
                        style="min-width: 120px"
                        v-for="(date, d) in module.total_range"
                        :key="`date${d}`"
                      >
                        {{ date.date }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      dense
                      style="height: 25px"
                      v-for="(moduleJob, mj) in module.module_jobs"
                      :key="`moduleJob_${mj}`"
                    >
                      <td>{{ moduleJob.name }}</td>
                      <td>{{ moduleJob.workshop?.description }}</td>
                      <td
                        v-for="(date, d) in module.total_range"
                        :key="`date${d}`"
                        :style="`background-color: ${
                          moduleJob.dateRange.find((md) => md.date == date.date)
                            ? moduleJob.dateRange.find(
                                (md) => md.date == date.date
                              ).color
                            : 'white'
                        }; height: 25px`"
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
            <v-row>
              <v-col></v-col>
              <v-spacer></v-spacer>
              <v-col md="3">
                <v-row>
                  <v-col md="1" class="mr-2"
                    ><v-icon color="green">mdi-circle</v-icon></v-col
                  >
                  <v-col> <h4>Estimated & Actually Worked</h4> </v-col>
                </v-row>
                <v-row>
                  <v-col md="1" class="mr-2"
                    ><v-icon color="orange">mdi-circle</v-icon></v-col
                  >
                  <v-col><h4>Estimated but No Actual Work Done</h4> </v-col>
                </v-row>
                <v-row>
                  <v-col md="1" class="mr-2">
                    <v-icon color="red">mdi-circle</v-icon></v-col
                  >
                  <v-col><h4>Not Estimated But Actual work Done</h4> </v-col>
                </v-row>
                <v-row>
                  <v-col md="1" class="mr-2"
                    ><v-icon color="yellow">mdi-circle</v-icon></v-col
                  >
                  <v-col
                    ><h4>Estimated But Actual Date not mentioned</h4>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn text class="mr-2" @click="show_module_details = false"
                >Close
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Timeline Pop UP -->
      <!-- Module Job Timeline Pop UP  -->
      <v-dialog v-model="show_module_job" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>
                {{ moduleJob.name + " Timeline" }}
              </h2>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_module_job = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-row>
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th style="min-width: 120px">Job Name</th>
                      <th
                        style="min-width: 120px"
                        v-for="(date, d) in moduleJob.dateRange"
                        :key="`date${d}`"
                      >
                        {{ date.date }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ moduleJob.name }}</td>
                      <td
                        v-for="(date, d) in moduleJob.dateRange"
                        :key="`date${d}`"
                        :style="`background-color: ${date.color}; height: 25px`"
                      ></td>
                    </tr>
                    <tr
                      v-for="(subModuleJob, smj) in moduleJob.module_jobs"
                      :key="`subModuleJob${smj}`"
                    >
                      <td>{{ subModuleJob.name }}</td>

                      <td
                        v-for="(date, d) in moduleJob.dateRange"
                        :key="`date${d}`"
                        :style="`background-color: ${
                          subModuleJob.dateRange.find(
                            (smj) => smj.date == date.date
                          )
                            ? subModuleJob.dateRange.find(
                                (smj) => smj.date == date.date
                              ).color
                            : 'white'
                        }; height: 25px`"
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-row>
            <v-row>
              <v-col></v-col>
              <v-spacer></v-spacer>
              <v-col md="3">
                <v-row>
                  <v-col md="1" class="mr-2"
                    ><v-icon color="green">mdi-circle</v-icon></v-col
                  >
                  <v-col> <h4>Estimated & Actually Worked</h4> </v-col>
                </v-row>
                <v-row>
                  <v-col md="1" class="mr-2"
                    ><v-icon color="orange">mdi-circle</v-icon></v-col
                  >
                  <v-col><h4>Estimated But Not Actually Worked</h4> </v-col>
                </v-row>
                <v-row>
                  <v-col md="1" class="mr-2">
                    <v-icon color="red">mdi-circle</v-icon></v-col
                  >
                  <v-col><h4>Not Estimated But Actually worked</h4> </v-col>
                </v-row>
                <v-row>
                  <v-col md="1" class="mr-2"
                    ><v-icon color="yellow">mdi-circle</v-icon></v-col
                  >
                  <v-col
                    ><h4>Estimated But No Actual date mentioned</h4>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn text class="mr-2" @click="show_module_job = false"
                >Close
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Job Timeline Pop UP -->
      <!-- Module Job Feedback Pop UP  -->
      <v-dialog v-model="show_module_job_feedback" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>
                {{ selectedNode.name + " Feedback" }}
              </h2>
            </span>
            <v-btn
              class="ml-5"
              :loading="isSaving"
              small
              :disabled="isSaving"
              color="primary"
              @click="saveModuleJobFeedbacks"
            >
              Save
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_module_job_feedback = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-row
              v-for="(feedback, f) in selectedNode.module_job_feedbacks"
              :key="`feedback_${f}`"
            >
              <v-col v-if="project.type != 'TEMPLATE'">
                <h3>
                  {{ feedback.category }}
                </h3>
              </v-col>
              <v-col v-if="project.type != 'TEMPLATE'">
                <v-rating v-model="feedback.rating"></v-rating>
              </v-col>
              <v-col v-if="project.type != 'TEMPLATE'">
                <v-textarea
                  v-model="feedback.remark"
                  outlined
                  counter
                  rows="2"
                  label="Remark"
                  clearable
                  clear-icon="mdi-close-circle"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Job Feedback Pop UP -->
      <!-- Module Job Document Pop UP  -->
      <v-dialog v-model="show_module_job_document" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>
                {{ selectedNode.name + " Document" }}
              </h2>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_module_job_document = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <tbody>
                  <tr
                    v-for="(document, d) in selectedNode.module_job_documents"
                    :key="`document${d}`"
                  >
                    <td>
                      <v-btn
                        rounded
                        color="primary"
                        target="_blank"
                        :href="`${mediaUrl + document.documentpath}`"
                        ><v-icon>mdi-file</v-icon>
                        {{ document.documentpath | filename }}
                      </v-btn>
                    </td>
                    <td>
                      <!-- Delete Button -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="primary"
                            icon
                            @click="
                              delete_data(document.id, 'module_job_documents')
                            "
                          >
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete Document</span>
                      </v-tooltip>
                      <!-- End Delete Button -->
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Job Feedback Pop UP -->
      <!-- Supplier List Pop UP  -->
      <v-dialog v-model="show_supplier_list" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>Supplier List</h2>
              <v-btn
                color="primary"
                @click="SendTemplate()"
                :loading="isSendingTemplate"
                :disabled="isSendingTemplate"
                >Send Mail
              </v-btn>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_supplier_list = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">
                      <v-checkbox
                        @click="selectAll()"
                        label="Select All"
                        v-model="is_select_all"
                      ></v-checkbox>
                    </th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(supplier, s) in suppliers" :key="`supplier${s}`">
                    <td>{{ s + 1 }}</td>
                    <td>
                      <v-checkbox v-model="supplier.is_selected"></v-checkbox>
                    </td>
                    <td>{{ supplier.name }}</td>
                    <td>{{ supplier.email }}</td>
                    <td>
                      <v-text-field
                        v-model="supplier.note"
                        outlined
                        dense
                        label="Note"
                        hide-details="auto"
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- /Supplier List Pop UP  -->
      <!-- Quotation Module Pop UP -->
      <v-dialog v-model="show_quotation_modules" max-width="1230px">
        <v-card elevation="2">
          <v-card-title>
            <span>
              <h2>Module Listed within Quotation</h2>
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="show_quotation_modules = false">
              <v-icon>mdi-window-close </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-5">
            <v-btn dark color="indigo" @click="copyFromQuotation">Copy</v-btn>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">
                      <v-checkbox
                        @click="selectAllModule"
                        label="Select All"
                        v-model="is_select_all_module"
                      ></v-checkbox>
                    </th>
                    <th class="text-left">Name</th>
                    <th class="text-left">Qty</th>
                  </tr>
                </thead>
                <tbody
                  v-for="(qmodule, m) in quotationModules"
                  :key="`qmodule${m}`"
                >
                  <tr>
                    <td>{{ m + 1 }}</td>
                    <td>CATEGORY</td>
                    <td>
                      <v-checkbox
                        v-model="qmodule.is_selected"
                        @change="selectAllModuleJob(qmodule)"
                      ></v-checkbox>
                    </td>
                    <td>{{ qmodule.name }}</td>
                  </tr>
                  <tr
                    v-for="(qmodulejob, mj) in qmodule.module_jobs"
                    :key="`qmodulejob${mj}`"
                  >
                    <td>{{ m + 1 + " - " + (mj + 1) }}</td>
                    <td>JOB</td>
                    <td>
                      <v-checkbox v-model="qmodulejob.is_selected"></v-checkbox>
                    </td>
                    <td>{{ qmodulejob.name }}</td>
                    <td>
                      <v-text-field
                        :placeholder="`${qmodulejob.qty}`"
                        :rules="[
                          (v) =>
                            v <= qmodulejob.qty ||
                            `Quantity cannot be greater than ${qmodulejob.qty}`,
                        ]"
                        :label="`Qty ${
                          project.type == 'TEMPLATE' ? '/ Hrs' : ''
                        }`"
                        type="number"
                        v-model="qmodulejob.request_qty"
                        outlined
                        dense
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- / Module Job Feedback Pop UP -->
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import backbutton from "@/components/backbutton.vue";
import moment from "moment";
export default {
  components: { backbutton },
  name: "ModulesPage",
  data() {
    return {
      form: {
        project_id: "",
        category_id: "",
        sub_category_id: "",
        type: "",
      },
      // Tree data For treeview
      treeData: [],
      modules: [],
      project: [],

      selectedNode: {}, // Active Selected Node
      active: [],

      module: {}, //If Selected Node type is Module
      moduleJob: {}, //If Selected Node type is Module Job
      subModuleJob: {}, //If Selected Node type is Sub Module Job

      workshopItems: [{ id: 0, text: "Select Workshop", value: "0" }],
      templateItems: [{ id: 0, text: "Select Template", value: "0" }],
      quotationItems: [{ id: 0, text: "Select Quotation", value: "0" }],
      projectItems: [{ id: 0, text: "Select Project", value: "0" }],
      currencyItems: [{ id: 0, text: "Select Currency", value: "0" }],
      categoryItems: [{ id: 0, text: "Select Category", value: "0" }],
      suppliers: [],
      supplierItems: [{ id: "", text: "Select Vendor", value: "" }],
      quotationModules: [],
      sub_categories: [],
      sub_categoryItems: [{ id: 0, text: "Select Sub Category", value: "0" }],
      statusItems: [
        { id: "0", text: "Inprogress", value: 0 },
        { id: "1", text: "Waiting for spares", value: 1 },
        { id: "2", text: "Completed", value: 2 },
        { id: "3", text: "Waiting for Confirmation", value: 3 },
      ],
      SparestatusItems: [
        { id: "0", text: "Inprogress", value: 0 },
        { id: "1", text: "Order confirmed", value: 1 },
        { id: "2", text: "Waiting for Approval", value: 2 },
        { id: "3", text: "Waiting for Price / Delivery", value: 3 },
        { id: "4", text: "Recieved", value: 4 },
      ],
      standardItems: [
        { id: "1", text: "Cleaniness", value: 1 },
        { id: "2", text: "Organised", value: 2 },
        { id: "3", text: "Quality of Work", value: 3 },
      ],
      QuantityTypeItems: ["ITEM COST", "OTHER COST"],
      Rating: [5, 4, 3, 2, 1, 0],
      nowDate: new Date().toISOString().slice(0, 10),

      isLoading: false,
      isSaving: false,
      show_module_details: false,
      show_module_job: false,
      show_module_job_feedback: false,
      show_module_job_document: false,
      show_supplier_list: false,
      show_quotation_modules: false,
      isSendingTemplate: false,
      is_select_all: true,
      is_select_all_module: false,
      logged_in_as: "ADMIN",
      title: "",
    };
  },
  mounted() {
    this.form.type = this.$route.query.type;
    if (this.$route.query.logged_in) {
      this.logged_in_as = this.$route.query.logged_in;
    }
    this.getMasters();
  },
  methods: {
    selectAll() {
      this.suppliers.forEach((supplier) => {
        supplier.is_selected = this.is_select_all;
      });
    },
    selectAllModule() {
      this.quotationModules.forEach((qmodule) => {
        qmodule.is_selected = this.is_select_all_module;
        qmodule.module_jobs.forEach((qmodulejob) => {
          qmodulejob.is_selected = this.is_select_all_module;
        });
      });
      // console.log(this.modules);
    },
    selectAllModuleJob(module) {
      module.module_jobs.forEach((qmodulejob) => {
        qmodulejob.is_selected = module.is_selected;
      });
      // console.log(module);
    },
    async getMasters() {
      let masters = await axios.get(
        `modules/masters?category_type=${this.$route.query.type}`
      );
      masters = masters.data;
      this.suppliers = masters.suppliers;
      this.suppliers.forEach((supplier) => {
        supplier.is_selected = true;
        this.supplierItems.push({
          id: supplier.id,
          text: supplier.name + " - " + supplier.email,
          value: supplier.id,
        });
      });
      masters.projects.forEach((project) => {
        if (project.type == "PROJECT") {
          this.projectItems.push({
            id: project.id,
            text: project.name,
            value: project.id,
          });
        } else if (project.type == "QUOTATION") {
          this.quotationItems.push({
            id: project.id,
            text: project.name,
            value: project.id,
          });
        } else {
          this.templateItems.push({
            id: project.id,
            text: project.name,
            value: project.id,
          });
        }
      });
      masters.workshops.forEach((workshop) => {
        this.workshopItems.push({
          id: workshop.id,
          text: workshop.description,
          value: workshop.id,
        });
      });
      masters.currencies.forEach((currency) => {
        this.currencyItems.push({
          id: currency.id,
          text: currency.description,
          value: currency.id,
        });
      });
      masters.categories.forEach((category) => {
        this.categoryItems.push({
          id: category.id,
          text: category.name,
          value: category.id,
        });
        if (category.value_lists.length) {
          category.value_lists.forEach((sub_category) => {
            this.sub_categories.push(sub_category);
            this.sub_categoryItems.push({
              id: sub_category.id,
              text: sub_category.description,
              value: sub_category.id,
              value_id: sub_category.value_id,
            });
          });
        }
      });
      if (this.$route.query.project_id) {
        this.form.project_id = parseInt(this.$route.query.project_id);
      }
      if (this.$route.query.category_id) {
        this.form.category_id = this.$route.query.category_id;
      }
      if (this.$route.query.sub_category_id) {
        this.form.sub_category_id = this.$route.query.sub_category_id;
      }
      if (
        this.$route.query.project_id ||
        this.$route.query.category_id ||
        this.$route.query.sub_category_id
      ) {
        this.getData();
      }
    },
    async getData() {
      this.modules = [];
      this.treeData = [];
      this.selectedNode = [];
      this.isLoading = true;
      let project = await axios.get(`/projects/${this.form.project_id}`);
      this.project = project.data.data;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let modules = [];
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&type=" +
        this.form.type +
        "&project_id=" +
        this.form.project_id +
        "&category_id=" +
        this.form.category_id +
        "&sub_category_id=" +
        this.form.sub_category_id;
      modules = await axios.get(`modules?${query}`);
      this.modules = modules.data.data;
      if (this.modules.length > 0) {
        this.modules.forEach((module) => {
          let module_name = module.category.name;
          if (module.sub_category) {
            module_name = module_name + " : " + module.sub_category.description;
          }
          if (
            module.module_jobs.length > 0 &&
            module.category.name != "SPARES"
          ) {
            module_name =
              module_name +
              " [ Total Jobs :" +
              module.module_jobs.length +
              " ]";
          }
          if (
            module.module_jobs.length > 0 &&
            module.category.name == "SPARES"
          ) {
            module_name =
              module_name +
              " [ Total Spares :" +
              module.module_jobs.length +
              " ]";
            this.title = module.category.name;
          }
          if (module.category.name == "SPARES") {
            this.title = module.category.name;
          }
          let m = {
            id: module.id,
            name: module_name,
            title: this.title,
            children: [],
          };
          if (module.module_jobs.length > 0) {
            module.module_jobs.forEach((moduleJob) => {
              let module_job_name = moduleJob.name;
              if (moduleJob.total_cost) {
                module_job_name =
                  module_job_name + " || SEV: " + moduleJob.total_cost;
              }
              if (
                moduleJob.module_job_spares.length &&
                module.category.name != "SPARES"
              ) {
                let total_spare_cost = 0;
                moduleJob.module_job_spares.forEach((mjs) => {
                  total_spare_cost += parseInt(mjs.total_cost);
                });
                module_job_name =
                  module_job_name + " || SPA: " + total_spare_cost;
              }
              if (
                moduleJob.module_job_spares.length &&
                module.category.name == "SPARES"
              ) {
                let total_spare_cost = 0;
                moduleJob.module_job_spares.forEach((mjs) => {
                  total_spare_cost += parseInt(mjs.total_cost);
                });
                module_job_name = " SPA: " + total_spare_cost;
                // this.title = module.category.name;
              }
              // let title;
              let mj = {
                id: module.id + "-" + moduleJob.id,
                name: module_job_name,
                // title: this.title,
                children: [],
              };
              /** Add if Any Sub jobs Present */
              moduleJob.module_jobs.forEach((smj) => {
                let module_job_name = smj.name;
                if (smj.total_cost) {
                  module_job_name =
                    module_job_name + " || SEV: " + smj.total_cost;
                }
                if (
                  smj.module_job_spares.length &&
                  smj.category.name != "SPARES"
                ) {
                  let total_spare_cost = 0;
                  smj.module_job_spares.forEach((mjs) => {
                    total_spare_cost += parseInt(mjs.total_cost);
                  });
                  module_job_name =
                    module_job_name + " || SPA: " + total_spare_cost;
                }
                if (
                  smj.module_job_spares.length &&
                  smj.category.name == "SPARES"
                ) {
                  let total_spare_cost = 0;
                  smj.module_job_spares.forEach((mjs) => {
                    total_spare_cost += parseInt(mjs.total_cost);
                  });
                  module_job_name = " SPA: " + total_spare_cost;
                }
                let child = {
                  id: module.id + "-" + moduleJob.id + "-" + smj.id,
                  name: module_job_name,

                  children: [],
                };
                mj.children.push(child);
              });
              m.children.push(mj);
            });
          }
          this.treeData.push(m);
        });
      }
      console.log(this.treeData);
      this.isLoading = false;
    },
    getSubCategory() {
      this.sub_categoryItems = [
        { id: 0, text: "Select Sub Category", value: "0" },
      ];
      this.module.sub_category_id = "";
      this.module.sub_sub_category_id = "";
      let sub_category = this.sub_categories.filter(
        (sub_category) => sub_category.value_id == this.module.category_id
      );

      sub_category.forEach((sc) => {
        this.sub_categoryItems.push({
          id: sc.id,
          text: sc.description,
          value: sc.id,
          value_id: sc.value_id,
        });
      });
    },
    showModuleTimeline(module) {
      this.module = {};
      this.moduleJob = {};
      this.show_module_details = true;
      if (module) {
        // If Module
        this.module = module;
        let total_array = [];
        this.module.module_jobs.forEach((moduleJob) => {
          // Make a Blank array of Estimate Start & End Date
          let array = [
            moduleJob.estimate_start_date,
            moduleJob.estimate_end_date,
          ];

          if (moduleJob.actual_start_date) {
            // If Actual star Date added
            array.push(moduleJob.actual_start_date);
          }
          if (moduleJob.actual_end_date) {
            array.push(moduleJob.actual_end_date);
          }
          array.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          });
          let fromDate = moment(array[0]);
          let toDate = moment(array[array.length - 1]);

          let dateRange = [];
          while (fromDate <= toDate) {
            let ld = fromDate.format("YYYY-MM-DD");
            let date = {
              date: ld,
            };
            dateRange.push(date);
            fromDate = moment(fromDate).add(1, "days");
          }

          let estimate_date_range = [];
          let estimate_start_date = moment(moduleJob.estimate_start_date);
          let estimate_end_date = moment(moduleJob.estimate_end_date);
          while (estimate_start_date <= estimate_end_date) {
            let ld = estimate_start_date.format("YYYY-MM-DD");
            estimate_date_range.push(ld);
            estimate_start_date = moment(estimate_start_date).add(1, "days");
          }

          let actual_start_date = moment(moduleJob.actual_start_date);
          let actual_end_date = moment(moduleJob.actual_end_date);

          let actual_date_range = [];
          while (actual_start_date <= actual_end_date) {
            let ld = actual_start_date.format("YYYY-MM-DD");
            actual_date_range.push(ld);
            actual_start_date = moment(actual_start_date).add(1, "days");
          }

          dateRange.forEach((date) => {
            date.actual_exists = actual_date_range.some(function (actual_date) {
              return actual_date === date.date;
            });
            date.estimate_exists = estimate_date_range.some(function (
              estimate_date
            ) {
              return estimate_date === date.date;
            });

            if (
              date.estimate_exists == true &&
              moduleJob.actual_start_date == null
            ) {
              date.color = "yellow";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == false
            ) {
              date.color = "orange";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == true
            ) {
              date.color = "green";
            } else if (
              date.estimate_exists == false &&
              date.actual_exists == true
            ) {
              date.color = "red";
            } else {
              date.color = "white";
            }
          });
          moduleJob.dateRange = dateRange;
          total_array = total_array.concat(array);
        });
        total_array = [
          ...new Set(
            total_array.sort((a, b) => {
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            })
          ),
        ];
        let t_fromDate = moment(total_array[0]);
        let t_toDate = moment(total_array[total_array.length - 1]);
        let total_range = [];
        while (t_fromDate <= t_toDate) {
          let ld = t_fromDate.format("YYYY-MM-DD");
          let date = {
            date: ld,
          };
          total_range.push(date);
          t_fromDate = moment(t_fromDate).add(1, "days");
        }
        this.module.total_range = total_range;
      }
    },
    showModuleJobTimeline(moduleJob) {
      this.moduleJob = {};
      this.show_module_job = true;
      if (moduleJob) {
        // If Module Job
        this.moduleJob = moduleJob;
        // Make a Blank array of Estimate Start & End Date
        let array = [
          this.moduleJob.estimate_start_date,
          this.moduleJob.estimate_end_date,
        ];

        if (this.moduleJob.actual_start_date) {
          // If Actual star Date added
          array.push(this.moduleJob.actual_start_date);
        }
        if (this.moduleJob.actual_end_date) {
          array.push(this.moduleJob.actual_end_date);
        }
        array.sort((a, b) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
        let fromDate = moment(array[0]);
        let toDate = moment(array[array.length - 1]);

        let dateRange = [];
        while (fromDate <= toDate) {
          let ld = fromDate.format("YYYY-MM-DD");
          let date = {
            date: ld,
          };
          dateRange.push(date);
          fromDate = moment(fromDate).add(1, "days");
        }

        let estimate_date_range = [];
        let estimate_start_date = moment(this.moduleJob.estimate_start_date);
        let estimate_end_date = moment(this.moduleJob.estimate_end_date);
        while (estimate_start_date <= estimate_end_date) {
          let ld = estimate_start_date.format("YYYY-MM-DD");
          estimate_date_range.push(ld);
          estimate_start_date = moment(estimate_start_date).add(1, "days");
        }

        let actual_start_date = moment(this.moduleJob.actual_start_date);
        let actual_end_date = moment(this.moduleJob.actual_end_date);

        let actual_date_range = [];
        while (actual_start_date <= actual_end_date) {
          let ld = actual_start_date.format("YYYY-MM-DD");
          actual_date_range.push(ld);
          actual_start_date = moment(actual_start_date).add(1, "days");
        }

        dateRange.forEach((date) => {
          date.actual_exists = actual_date_range.some(function (actual_date) {
            return actual_date === date.date;
          });
          date.estimate_exists = estimate_date_range.some(function (
            estimate_date
          ) {
            return estimate_date === date.date;
          });

          if (
            date.estimate_exists == true &&
            moduleJob.actual_start_date == null
          ) {
            date.color = "yellow";
          } else if (
            date.estimate_exists == true &&
            date.actual_exists == false
          ) {
            date.color = "orange";
          } else if (
            date.estimate_exists == true &&
            date.actual_exists == true
          ) {
            date.color = "green";
          } else if (
            date.estimate_exists == false &&
            date.actual_exists == true
          ) {
            date.color = "red";
          } else {
            date.color = "";
          }
        });
        this.moduleJob.dateRange = dateRange;
        // Sub Module Job Timeline Calculation
        this.moduleJob.module_jobs.forEach((subModuleJob) => {
          // Make a Blank array of Estimate Start & End Date
          let array = [
            subModuleJob.estimate_start_date,
            subModuleJob.estimate_end_date,
          ];

          if (subModuleJob.actual_start_date) {
            // If Actual star Date added
            array.push(subModuleJob.actual_start_date);
          }
          if (subModuleJob.actual_end_date) {
            array.push(subModuleJob.actual_end_date);
          }
          array.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          });
          let fromDate = moment(array[0]);
          let toDate = moment(array[array.length - 1]);

          let dateRange = [];
          while (fromDate <= toDate) {
            let ld = fromDate.format("YYYY-MM-DD");
            let date = {
              date: ld,
            };
            dateRange.push(date);
            fromDate = moment(fromDate).add(1, "days");
          }

          let estimate_date_range = [];
          let estimate_start_date = moment(subModuleJob.estimate_start_date);
          let estimate_end_date = moment(subModuleJob.estimate_end_date);
          while (estimate_start_date <= estimate_end_date) {
            let ld = estimate_start_date.format("YYYY-MM-DD");
            estimate_date_range.push(ld);
            estimate_start_date = moment(estimate_start_date).add(1, "days");
          }

          let actual_start_date = moment(subModuleJob.actual_start_date);
          let actual_end_date = moment(subModuleJob.actual_end_date);

          let actual_date_range = [];
          while (actual_start_date <= actual_end_date) {
            let ld = actual_start_date.format("YYYY-MM-DD");
            actual_date_range.push(ld);
            actual_start_date = moment(actual_start_date).add(1, "days");
          }

          dateRange.forEach((date) => {
            date.actual_exists = actual_date_range.some(function (actual_date) {
              return actual_date === date.date;
            });
            date.estimate_exists = estimate_date_range.some(function (
              estimate_date
            ) {
              return estimate_date === date.date;
            });

            if (
              date.estimate_exists == true &&
              subModuleJob.actual_start_date == null
            ) {
              date.color = "yellow";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == false
            ) {
              date.color = "orange";
            } else if (
              date.estimate_exists == true &&
              date.actual_exists == true
            ) {
              date.color = "green";
            } else if (
              date.estimate_exists == false &&
              date.actual_exists == true
            ) {
              date.color = "red";
            } else {
              date.color = "white";
            }
          });
          subModuleJob.dateRange = dateRange;
        });

        console.log(this.moduleJob);
      }
    },
    getActiveValue(e) {
      let id = e[0].toString();
      let module_id = id.split("-")[0];
      let module_job_id = id.split("-")[1];
      let sub_module_job_id = id.split("-")[2];
      // console.log(e);
      this.module = this.modules.find((m) => m.id == module_id);
      this.module.node_type = "module";
      this.selectedNode = this.module;
      if (module_job_id) {
        // Module Job
        this.moduleJob = this.module.module_jobs.find(
          (mj) => mj.id == module_job_id
        );
        // if (this.module.category?.name == "SPARES") {
        //   this.moduleJob.node_type = "";
        // } else {
        this.moduleJob.node_type = "module_job";
        // }
        this.moduleJob.category = this.module.category.name;
        this.selectedNode = this.moduleJob;
        if (sub_module_job_id) {
          // Sub Module Job
          this.subModuleJob = this.moduleJob.module_jobs.find(
            (mj) => mj.id == sub_module_job_id
          );
          this.subModuleJob.node_type = "sub_module_job";
          this.selectedNode = this.subModuleJob;
          console.log(this.subModuleJob);
        }
      } else {
        // Module
        this.getSubCategory();
        this.module.sub_category_id = this.selectedNode.sub_category?.id;
      }
      console.log(this.selectedNode);
    },
    addEmptyModuleJobSpare() {
      this.selectedNode.module_job_spares.push({
        module_id: this.module.id,
        module_job_id: this.module_id,
        site_id: this.site.id,
        description: "",
        supplier_name: "",
        order_date: "",
        expected_delivery_date: "",
        actual_delivery_date: "",
        cost: 0,
        transportation_cost: 0,
        total_cost: 0,
        status: 0,
      });
    },
    deleteModuleJobSpare(moduleJobSpare) {
      this.moduleJob.module_job_spares =
        this.moduleJob.module_job_spares.filter((ar) => ar != moduleJobSpare);
    },
    addEmptyModuleJobQuantity() {
      this.moduleJob.module_job_quantities.push({
        module_job_id: this.module_id,
        site_id: this.site.id,
        unit_cost: 0,
        total_cost: 0,
        type: "ITEM COST",
        supplier_id:
          this.logged_in_as == "ADMIN" ? "" : this.project.supplier_id,
      });
    },
    deleteModuleJobQuantity(moduleJobQuantity) {
      this.moduleJob.module_job_quantities =
        this.moduleJob.module_job_quantities.filter(
          (ar) => ar != moduleJobQuantity
        );
    },
    async delete_data(id, table) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=${table}`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
        this.show_module_job_document = false;
      }
    },
    async saveModule() {
      try {
        this.isSaving = true;
        await axios.post("/modules", this.module ? this.module : this.form);
        this.isSaving = false;
        this.getData();
      } catch (e) {
        console.log(e);
        this.isSaving = false;
      }
    },
    async saveModuleJob() {
      try {
        this.isSaving = true;
        this.selectedNode.project_type = this.project.type;
        this.selectedNode.category = this.module.category.name;
        let total_handling_charge = 0;
        let total_quantity = 0;
        let total_quantity_cost = 0;
        if (this.selectedNode.module_job_quantities) {
          this.selectedNode.module_job_quantities.forEach((mjq) => {
            if (!mjq.id) {
              if (mjq.type == "ITEM COST") {
                total_quantity += parseInt(mjq.qty);
                total_quantity_cost += parseInt(mjq.total_cost);
              } else {
                total_handling_charge += parseInt(mjq.total_cost);
              }
            }
          });
        }
        this.selectedNode.total_handling_charge =
          parseInt(this.selectedNode.total_handling_charge) +
          parseInt(total_handling_charge);
        this.selectedNode.total_cost =
          parseInt(this.selectedNode.total_cost) +
          parseInt(total_quantity_cost);
        console.log(this.selectedNode.total_cost);
        this.selectedNode.qty =
          parseInt(this.selectedNode.qty) + parseInt(total_quantity);

        this.selectedNode.cost = Math.round(
          parseInt(this.selectedNode.total_cost / this.selectedNode.qty)
        );
        this.calculated(this.selectedNode);
        await axios.post("/module_jobs", this.selectedNode);
        await this.handleFileUpload();
        this.isSaving = false;
        this.getData();
      } catch (e) {
        console.log(e);
        this.isSaving = false;
      }
    },
    async handleFileUpload() {
      if (this.$refs.file != null) {
        let list = this.$refs.file.files;
        console.log(list);
        let formData = new FormData();
        formData.append("module_job_id", this.selectedNode.id);
        let attachment_count = 0;
        list.forEach((att, i) => {
          let attachment_name = "documentpath_" + i;

          let attachment = this.$refs.file.files[i];
          formData.append(attachment_name, attachment);
          attachment_count++;
        });
        formData.append("attachment_count", attachment_count);
        await axios
          .post("upload_module_job_documents", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .catch(function () {
            console.log("FAILURE!!");
          });
      }
    },
    createNewModule() {
      this.module = {
        project_id: this.form.project_id,
        category_id: "",
        sub_category_id: "",
        type: this.form.type,
        node_type: "module",
        module_jobs: [],
      };
      this.selectedNode = this.module;
    },
    addJob(parent) {
      if (parent.node_type == "module_job") {
        /** If Parent Node is Module Job, Then Create a Child node with Sub Module Job Type */
        this.subModuleJob = {
          module_id: "",
          module_job_id: parent.id,
          status: 0,
          site_id: module.site_id,
          node_type: "sub_module_job",
          qty: 0,
          cost: 0,
          total_cost: 0,
          module_job_spares: [],
          module_job_details: [],
          module_job_feedbacks: [],
        };
        this.selectedNode = this.subModuleJob;
      } else {
        /** If Parent Node is Module , Then Create a Child node with Module Job Type */
        this.moduleJob = {
          module_id: parent.id,
          status: 0,
          site_id: parent.site_id,
          node_type: "module_job",
          qty: 0,
          cost: 0,
          total_cost: 0,
          module_job_spares: [],
          module_job_details: [],
          module_job_feedbacks: [],
        };
        this.selectedNode = this.moduleJob;
      }
    },
    capitalize(string) {
      if (string) {
        let capitalized_string =
          string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        return capitalized_string;
      }
    },
    calculated(selectedNode) {
      let total_cost = parseInt(selectedNode.qty) * parseInt(selectedNode.cost);
      if (selectedNode.discount_percentage) {
        total_cost =
          total_cost -
          (total_cost * parseInt(selectedNode.discount_percentage)) / 100;
      }
      if (selectedNode.discount_amount)
        total_cost = total_cost - parseInt(selectedNode.discount_amount);
      if (selectedNode.additional_percentage) {
        total_cost =
          total_cost +
          (total_cost * parseInt(selectedNode.additional_percentage)) / 100;
      }
      if (selectedNode.additional_amount)
        total_cost = total_cost + parseInt(selectedNode.additional_amount);
      selectedNode.total_cost = total_cost;
    },
    calculated_total(spare) {
      spare.total_cost =
        parseInt(spare.cost) + parseInt(spare.transportation_cost);
    },
    showFeedback(module_job) {
      this.show_module_job_feedback = true;
      this.selectedNode = module_job;
      this.standardItems.forEach((standard) => {
        let fm = this.selectedNode.module_job_feedbacks.find(
          (f) => f.category == standard.text
        );
        if (!fm) {
          let feedback = {
            category: standard.text,
            module_id: module_job.module_id,
            module_job_id: module_job.id,
            rating: 0,
            remark: "",
          };
          this.selectedNode.module_job_feedbacks.push(feedback);
        } else {
          fm.rating = parseInt(fm.rating);
        }
      });
    },
    async saveModuleJobFeedbacks() {
      try {
        this.isSaving = true;
        let payload = {
          datas: this.selectedNode.module_job_feedbacks,
        };
        await axios.post(
          `module_jobs/${this.selectedNode.id}/module_job_feedbacks_multiple`,
          payload
        );
        this.isSaving = false;
        this.getData();
      } catch (e) {
        console.log(e);
        this.isSaving = false;
      }
      this.show_module_job_feedback = false;
    },
    async openCopyQuotation() {
      let quotation = await axios.get(`/projects/${this.form.quotation_id}`);
      quotation = quotation.data.data;
      let modules = [];
      quotation.modules.forEach(async (module) => {
        delete module.id; // delete the quotations.module ID
        module.project_id = this.form.project_id;
        let category_id = module.category_id;
        let sub_category_id = module.sub_category_id;
        let module_name = module.category.name;
        if (module.sub_category) {
          module_name = module_name + " : " + module.sub_category.description;
        }
        module.name = module_name;

        /**
         * Check whether Any Existing Module has the same Category & Sub Category
         */
        let exist_module = this.modules.find(
          (m) =>
            m.category_id == category_id && m.sub_category_id == sub_category_id
        );
        if (exist_module) {
          module.id = exist_module.id; // append the projects.module ID to Update the existing module
          module.module_jobs.forEach((module_job) => {
            delete module_job.id; // delete the module job ID
            let module_job_name = module_job.name;
            /**
             * Check whether Any Existing Module Job has the same name
             */
            let exist_module_job = exist_module.module_jobs.find(
              (mj) => mj.name == module_job_name
            );
            if (exist_module_job) {
              module_job.id = exist_module_job.id; // append the modeule job ID to Update the existing module job
              module_job.module_id = exist_module.id; // append the modeule ID to Update the existing module
              // Module Job Quatities
              module_job.module_job_quantities.forEach((quantity) => {
                delete quantity.id; // delete the quantity ID
                quantity.module_id = exist_module.id;
                quantity.module_job_id = exist_module_job.id;
              });
              //  Module Job Spares
              module_job.module_job_spares.forEach((spare) => {
                delete spare.id; // delete the spare ID
                spare.module_id = exist_module.id;
                spare.module_job_id = exist_module_job.id;
              });
            } else {
              module_job.module_job_quantities.forEach((quantity) => {
                delete quantity.id; // delete the quantity ID
              });
              //  Module Job Spares
              module_job.module_job_spares.forEach((spare) => {
                delete spare.id; // delete the spare ID
              });
            }
          });
        } else {
          // If New Module than every module job with in it should be new
          module.module_jobs.forEach((module_job) => {
            delete module_job.id;
            module_job.module_job_quantities.forEach((quantity) => {
              delete quantity.id;
            });
            module_job.module_job_spares.forEach((apare) => {
              delete apare.id;
            });
          });
        }

        modules.push(module);
      });
      this.quotationModules = modules;
      this.show_quotation_modules = true;
    },
    async copyFromQuotation_old() {
      let quotation = await axios.get(`/projects/${this.form.quotation_id}`);
      quotation = quotation.data.data;
      let modules = [];
      quotation.modules.forEach(async (module) => {
        delete module.id; // delete the quotations.module ID
        module.project_id = this.form.project_id;
        let category_id = module.category_id;
        let sub_category_id = module.sub_category_id;
        /**
         * Check whether Any Existing Module has the same Category & Sub Category
         */
        let exist_module = this.modules.find(
          (m) =>
            m.category_id == category_id && m.sub_category_id == sub_category_id
        );
        if (exist_module) {
          /**
           * if Exist,
           * Then Update Module Jobs
           */
          module.module_jobs.forEach((mj) => {
            /**
             * Check whether Any Existing Module Job has the same Name
             */
            let exist_module_job = exist_module.module_jobs.find(
              (emj) => emj.name == mj.name
            );
            if (exist_module_job) {
              /**
               * if Exist,
               * Then Update Module Jobs
               */
            } else {
              /**
               * if Not,
               * Then Add Module Jobs
               */
              exist_module.module_jobs.push(mj);
            }
          });
          modules.push(exist_module);
        } else {
          /**
           * if Doesn't Exist,
           * Then Add Module
           */
          modules.push(module);
        }
      });
      console.log(modules);
      // let payload = {
      //   datas: modules,
      // };
      // await axios.post("/modules/store_multiple", payload);
      // this.getData();
    },
    async copyFromQuotation() {
      this.moduleCopy = [];
      this.quotationModules.forEach((qmodule) => {
        let newModule = "";
        if (qmodule.is_selected == true) {
          newModule = qmodule;
          newModule.selected_module_jobs = [];
          qmodule.module_jobs.forEach((qmodulejob) => {
            if (qmodulejob.is_selected == true) {
              // console.log(qmodulejob);
              if (qmodulejob.request_qty) {
                qmodulejob.qty = qmodulejob.request_qty;
              }
              this.calculated(qmodulejob);
              newModule.selected_module_jobs.push(qmodulejob);
            }
          });
        }
        if (newModule) {
          this.moduleCopy.push(newModule);
          // console.log(this.moduleCopy);
          this.moduleCopy.forEach((m) => {
            m.module_jobs = [];
            if (m.selected_module_jobs.length > 0) {
              m.module_jobs = m.selected_module_jobs;
              // m.selected_module_jobs.forEach((nmj) => {
              //   m.module_jobs.push(nmj);
              // });
            }
          });
        }
      });
      let payload = {
        datas: this.moduleCopy,
      };
      console.log(payload);
      await axios.post("/modules/store_multiple", payload);
      this.getData();
      this.show_quotation_modules = false;
    },
    async SendTemplate() {
      this.isSendingTemplate = true;
      let supplier_ids = [];
      this.suppliers.forEach((supplier) => {
        let data = supplier.id + "_" + (supplier.note ? supplier.note : "");
        if (supplier.is_selected) {
          supplier_ids.push(data);
        }

        console.log(supplier_ids);
      });
      await axios.post(
        `/projects/send_template?project_id=${this.project.id}&supplier_ids=${supplier_ids}`
      );
      this.isSendingTemplate = false;
    },
    calculate_mjq(mjq) {
      mjq.total_cost = parseInt(mjq.unit_cost) * parseInt(mjq.qty);
    },
    async handleFileQuotationDocumentUpload() {
      if (this.$refs.doc != null) {
        var _this = this;
        let list = this.$refs.doc.files;
        console.log(list);
        let formData = new FormData();
        formData.append("project_id", this.project.id);
        let attachment_count = 0;
        list.forEach((att, i) => {
          let attachment_name = "documentpath_" + i;

          let attachment = this.$refs.doc.files[i];
          formData.append(attachment_name, attachment);
          attachment_count++;
        });
        formData.append("attachment_count", attachment_count);
        await axios
          .post("upload_project_documents", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            location.reload();
          })
          .catch(function () {
            console.log("FAILURE!!");
          });
      }
    },
    isEditable() {
      var response = false;
      if (this.roleName == "Handler") {
        if (this.project.created_by_id == this.user.id) {
          response = true;
        }
      } else {
        response = true;
      }
      // console.log(response);
      return response;
    },
  },
};
</script>
<style scoped>
.v-treeview {
  overflow-y: auto !important;
  text-overflow: initial;
  height: 500px;
}
.bold {
  font-weight: bold;
}
</style>
